<template>
  <div class="krj-toolbar__extras">
    <el-button
      v-if="showToggle"
      :icon="searchVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
      circle
      size="small"
      :title="searchVisible ? '隐藏搜索' : '显示搜索'"
      @click="onToggle"
    />
    <el-button
      icon="el-icon-refresh"
      circle
      size="small"
      :loading="loading"
      title="刷新"
      @click="onRefresh"
    />
  </div>
</template>

<script>
/**
 * ToolbarExtras — 工具栏第二行右侧的两个通用图标按钮：
 *   - 隐藏/显示搜索：组件内部自管 searchVisible 状态，点击即翻转并 emit 新值；
 *   - 刷新：emit 'refresh'，由 listToolbarExtras mixin 调用页面 getList()。
 *
 * 由 listToolbarExtras mixin 自动注入到 .krj-toolbar（Grid 布局下置于第二行右侧）。
 * showToggle=false 时不渲染「隐藏/显示搜索」按钮（用于没有搜索项的列表页）。
 *
 * 注意：searchVisible / loading 用组件内部 data 管理（非 prop），
 *       避免父级直接改 prop 引发的不可预期行为与 loading 卡死。
 */
export default {
  name: 'ToolbarExtras',
  props: {
    showToggle: { type: Boolean, default: true }
  },
  data() {
    return {
      searchVisible: true,
      loading: false
    }
  },
  methods: {
    onToggle() {
      this.searchVisible = !this.searchVisible
      this.$emit('toggle-search', this.searchVisible)
    },
    onRefresh() {
      this.loading = true
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.krj-toolbar__extras {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  .el-button.is-circle {
    padding: 6px;
    border-color: $border-color;
    color: $text-secondary;
    background: $bg-surface;
    transition: color .18s ease, border-color .18s ease, background-color .18s ease;

    &:hover,
    &:focus {
      color: $brand-primary;
      border-color: $brand-primary;
      background: $bg-subtle;
    }
  }
}
</style>
